import React from "react";
import SeoComponent from "../common/SeoComponent";
import LayoutComponent from "../common/LayoutComponent";
import {t} from "../IntManager";
import $ from "jquery";


const scrollListener = (e) => {
    const st = $(e.target).scrollTop();
    const header = $('.nav__header');

    if (st > header.outerHeight()) {
        header.addClass('_scrolled');
    } else {
        header.removeClass('_scrolled');
    }

    if (st <= window.innerHeight && window.matchMedia("(min-width: 480px)").matches) {
        $('.js-scroll-down').css({
            transform: 'translate3d(0,-' + (st / 3) + 'px,0)'
        });
    }
};

export default class About extends SeoComponent {
    componentDidMount() {
        window.addEventListener('scroll', scrollListener);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', scrollListener);
    }

    render() {
        this.setMetaTags(t('main_title') + ' - ' + t('about'));

        const pageBackground = {
            backgroundImage: 'url(/static/media/river-outlook.jpg)'
        };

        return <LayoutComponent routerMatch={this.props.match}>
            <div className="page">
                <div className="u-overlay u-fixed u-fit u-pos-tl"></div>
                <div className="page__view relative">
                    <div style={pageBackground}></div>
                </div>
                <div className="page__inner u-absolute u-fit u-pos-tl">
                    <div className="about__hero u-pos-tl u-fit u-overflow">
                        <div className="about__hero-tile u-align-center relative js-scroll-down">
                            <div>
                                <svg className="about__logo">
                                    <use xlinkHref="/static/media/svg-symbols.svg#logo"/>
                                </svg>
                            </div>
                            <svg className="about__logo-text">
                                <use xlinkHref="/static/media/svg-symbols.svg#zaradye"/>
                            </svg>
                            <p className="about__hero-post">{t('about_park')}</p>
                        </div>
                        <div className="hero__more u-align-center u-absolute u-pos-l u-pos-r js-scroll-down">
                            <div className="btn-more u-inline-block">
                                <span
                                    className="slide-message__icon u-valign-middle u-inline-block relative u-overflow-h">
                                    <svg className="slider-message__triangle u-absolute u-fill--white">
                                        <use xlinkHref="/static/media/svg-symbols.svg#triangle-bottom"/>
                                    </svg>
                                    <svg className="slider-message__triangle u-absolute u-fill--white _clone">
                                        <use xlinkHref="/static/media/svg-symbols.svg#triangle-bottom"/>
                                    </svg>
                                    <span className="slider-message__circle u-pos-tl u-absolute u-fit u-block"/>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div name="content" className="page__content u-fit-w relative u-white-background">
                    <section className="about__container">
                        <div className="about__section relative">
                            <div className="row">
                                <div className="col-xs-12 col-sm-9">
                                    <img data-src="/static/media/mediacenter.jpg" alt="Медиацентр" className="about__image u-fit-w lazyload"/>
                                </div>
                                <div className="about__desc u-pos-r u-pos-b">
                                    <h2 className="about__title u-bold">{t('media_center')}</h2>
                                    <p dangerouslySetInnerHTML={{ __html:t('media_center_desc') }}></p>
                                </div>
                            </div>
                        </div>
                        <div className="about__section relative">
                            <div className="row">
                                <div className="col-xs-12 col-sm-offset-3 col-sm-9">
                                    <img data-src="/static/media/florarium.jpg" alt="Флорариум" className="about__image u-fit-w lazyload"/>
                                </div>
                                <div className="about__desc u-pos-l u-pos-b">
                                    <h2 className="about__title u-bold">{t('florarium')}</h2>
                                    <p dangerouslySetInnerHTML={{ __html:t('florarium_desc') }}></p>
                                </div>
                            </div>
                        </div>
                        <div className="about__section relative">
                            <div className="row">
                                <div className="col-xs-12 col-sm-9">
                                    <img data-src="/static/media/posolstvo.jpg" alt="Заповедное посольство" className="about__image u-fit-w lazyload"/>
                                </div>
                                <div className="about__desc u-pos-r u-pos-b">
                                    <h2 className="about__title u-bold">{t('nature_center')}</h2>
                                    <p dangerouslySetInnerHTML={{ __html:t('nature_center_desc') }}></p>
                                </div>
                            </div>
                        </div>
                        <div className="about__section relative">
                            <div className="row">
                                <div className="col-xs-12 col-sm-offset-3 col-sm-9">
                                    <img data-src="/static/media/ice_cave.jpg" alt="Ледяная пещера" className="about__image u-fit-w lazyload"/>
                                </div>
                                <div className="about__desc u-pos-l u-pos-b">
                                    <h2 className="about__title u-bold">{t('ice_cave')}</h2>
                                    <p dangerouslySetInnerHTML={{ __html:t('ice_cave_desc') }}></p>
                                </div>
                            </div>
                        </div>
                        <div className="about__section relative">
                            <div className="row">
                                <div className="col-xs-12 col-sm-9">
                                    <img data-src="/static/media/dome.jpg" alt="Купол" className="about__image u-fit-w lazyload"/>
                                </div>
                                <div className="about__desc u-pos-r u-pos-b">
                                    <h2 className="about__title u-bold">{t('dome')}</h2>
                                    <p dangerouslySetInnerHTML={{ __html:t('dome_desc') }}></p>
                                </div>
                            </div>
                        </div>
                        <div className="about__section relative">
                            <div className="row">
                                <div className="col-xs-12 col-sm-offset-3 col-sm-9">
                                    <img data-src="/static/media/undeground_museum.jpg" alt="Подземный музей"
                                         className="about__image u-fit-w lazyload"/>
                                </div>
                                <div className="about__desc u-pos-l u-pos-b">
                                    <h2 className="about__title u-bold">{t('underground_museum')}</h2>
                                    <p dangerouslySetInnerHTML={{ __html:t('underground_museum_desc') }}></p>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </LayoutComponent>;
    }
}



// WEBPACK FOOTER //
// ./src/js/components/About.js